<i18n
  src="@/locales/views/organization/reporting/process/show_reports.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :params="{ organization_id: organization_id }"
  />

  <bread-crumbs :labels="[module_name, harvest_process.name]"></bread-crumbs>

  <tabs-container v-model="option_tabs"></tabs-container>

  <div class="mt-6" v-show="option_tabs[0].current">
    <h1 class="page-title">
      <i :class="this.option_tabs[0].icon"></i>
      <span class="space-icon"></span>
      {{ option_tabs[0].name }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="rounded bg-white pt-4 px-12">

        <div
          class="pt-4 flex-1 border rounded my-5"
          v-if="report_by_agro_exporter"
        >
          <apexchart
            height="350"
            :options="chartOptions(report_by_agro_exporter, 'agro_exporter')"
            :series="series(report_by_agro_exporter)"
          ></apexchart>
        </div>

        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.agro_exporter") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.total_weight") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.discarded_weight") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      % {{ $t("model.harvested_batch.discarded_weight") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.ok_weight") }}
                    </th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="(item, index) in report_by_agro_exporter"
                    :key="index"
                  >
                    <td class="table-cell">
                      {{ item.name }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.total_weight) }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.discarded_weight) }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.percentage_discarded, 2) }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.ok_weight) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="mt-6" v-show="option_tabs[1].current">
    <h1 class="page-title">
      <i :class="this.option_tabs[1].icon"></i>
      <span class="space-icon"></span>
      {{ option_tabs[1].name }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="rounded bg-white pt-4 px-12">

        <div class="pt-4 flex-1 border rounded my-5" v-if="report_by_producer">
          <apexchart
            height="500"
            :options="chartOptions(report_by_producer, 'producer')"
            :series="series(report_by_producer)"
          ></apexchart>
        </div>

        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-pos">#</th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.producer") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.total_weight") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.discarded_weight") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      % {{ $t("model.harvested_batch.discarded_weight") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.harvested_batch.ok_weight") }}
                    </th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="(item, index) in report_by_producer"
                    :key="index"
                  >
                    <td class="table-cell-pos">
                      {{ index + 1 }}
                    </td>
                    <td class="table-cell">
                      {{ item.producer_name || item.organization_name }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.total_weight) }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.discarded_weight) }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.percentage_discarded, 2) }}
                    </td>
                    <td class="table-cell">
                      {{ numberWithPrecision(item.ok_weight) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import Requester from "@/views/organization/requesters/reporting/process/show_reports.js";

export default {
  name: "OrgReportingProcessShowReports",
  components: { apexchart: VueApexCharts },
  data() {
    return {
      harvest_process: {},
      report_by_agro_exporter: null,
      report_by_producer: null,
      option_tabs: [
        {
          name: this.$t("labels.by_agro_exporter"),
          icon: "fa-solid fa-chart-gantt",
          current: true
        },
        {
          name: this.$t("labels.by_producer"),
          icon: "fa-solid fa-chart-column",
          current: false
        }
      ]
    };
  },
  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => {
        this.fetchHarvestProcess();
        this.fetchRepByAgroExporters();
      })
    );
  },
  methods: {
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );

      this.harvest_process = response.data;
    },
    fetchRepByAgroExporters: async function () {
      let response = await Requester.fetchRepByAgroExporters(
        this.organization_id,
        this.harvest_process_id
      );

      this.report_by_agro_exporter = response.data;
    },
    fetchRepByProducers: async function () {
      let response = await Requester.fetchRepByProducers(
        this.organization_id,
        this.harvest_process_id
      );

      this.report_by_producer = response.data;
    },
    series: function (report) {
      if (report == null) return [];
      return [
        {
          name: this.$t("model.harvested_batch.ok_weight"),
          type: "column",
          data: report.map(item => item.ok_weight),
          color: "#86efac"
        },
        {
          name: this.$t("model.harvested_batch.discarded_weight"),
          type: "column",
          data: report.map(item => item.discarded_weight),
          color: "#F87171"
        }
      ];
    },
    chartOptions: function (report, type) {
      let f = () => {};
      if (type == "agro_exporter") {
        f = item => item.name;
      } else if (type == "producer") {
        f = item => (item.producer_name || item.organization_name).split(", ");
      }
      return {
        chart: { height: 350, stacked: true },
        stroke: { width: [0, 0] },
        plotOptions: { bar: { borderRadius: 5 } },
        labels: this.categories(report, f),
        xaxis: {
          labels: {
            rotate: -45,
            rotateAlways: true,
            style: { fontSize: "11px" }
          }
        },
        yaxis: [{ title: { text: "Kilogramos" } }],
        legend: { position: "top" },
        fill: { opacity: 1 }
      };
    },
    categories: function (report, f) {
      if (report == null) return [];

      return report.map(f);
    }
  },
  watch: {
    option_tabs: {
      deep: true,
      handler: function () {
        if (this.option_tabs[1].current && this.report_by_producer == null) {
          this.fetchRepByProducers();
        }
      }
    }
  }
};
</script>
